import styled from 'styled-components';
import { colors } from 'utils';

export const PrivacyWrapper = styled.div`
  color: ${colors.black};
`;
